import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import LanguagePicker from "../shared/Localization/LanguagePicker";
import ButtonsConstructor from "../shared/Input/Button/ButtonsConstructor";
import { E_Route } from "../../models/constants/Enum_Routes";
import { AppUtils } from "../../utils/AppUtils";
import { Redirect } from "../components";

class Footer extends Component {
	constructor() {
		super();

		this.state = {
			counter: 0,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevState.counter > 9) {
			this.setState({counter: 0});
		}
	}

	render({className, style}, {counter}) {

		return (
			<footer className={combineClasses("footer", className)} style={style}>
				{
					counter > 9 &&
					<Redirect to={E_Route.CONFIGURATION}/>
				}

				<nav className={"action-buttons left"}>
					<ButtonsConstructor
						buttons={[
							AppUtils.isDev && {
								icon: "cog",
								href: E_Route.CONFIGURATION,
							},
							{
								text: process.env.PACKAGE_VERSION,
								textTranslated: true,
								action: () => this.setState(state => ({counter: state.counter + 1})),
								routeWhitelist: [E_Route.HELP],
								className: "no-style version",
							}
						]}
						sharedProps={{className: "no-style"}}
					/>
				</nav>

				<LanguagePicker/>

				<nav className={"action-buttons right"}>
					<ButtonsConstructor
						buttons={[
							{
								icon: (
									<svg className={"fa"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
										<path key={0} d="M256 8C119 8 8 119.08 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 110a42 42 0 1 1-42 42 42 42 0 0 1 42-42zm56 254a12 12 0 0 1-12 12h-88a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h12v-64h-12a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h64a12 12 0 0 1 12 12v100h12a12 12 0 0 1 12 12z" className="fa-secondary"/>
										<path key={1} d="M256 202a42 42 0 1 0-42-42 42 42 0 0 0 42 42zm44 134h-12V236a12 12 0 0 0-12-12h-64a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h12v64h-12a12 12 0 0 0-12 12v24a12 12 0 0 0 12 12h88a12 12 0 0 0 12-12v-24a12 12 0 0 0-12-12z" className="fa-primary"/>
									</svg>
								),
								className: "help no-style",
								href: E_Route.HELP,
								routeBlacklist: [E_Route.HELP]
							}
						]}
					/>
				</nav>
			</footer>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,
		}
	}
}

export default Footer;
